export const formContainer = "space-y-6";
export const headerContainer = "border-b border-border-color pb-4";
export const headerTitle = "text-lg font-bold text-text-primary";
export const headerSubtitle = "text-xs md:text-sm text-text-secondary mt-1";

export const gridContainer = "grid grid-cols-1 md:grid-cols-2 gap-4";
export const inputGroup = "flex flex-col gap-1.5";
export const label = "text-sm font-semibold text-text-secondary";

export const inputClass = "w-full bg-bg-deep border border-border-color rounded-xl px-4 py-2.5 text-text-primary focus:outline-none focus:border-primary-accent focus:ring-1 focus:ring-primary-accent transition-colors";
export const selectClass = `${inputClass} appearance-none`;

export const footerContainer = "flex justify-end pt-4 border-t border-border-color";
export const submitButton = "bg-primary-accent hover:bg-primary-accent/90 text-white font-bold py-2.5 px-6 rounded-xl transition-colors cursor-pointer flex items-center justify-center min-w-[140px]";
export const spinnerIcon = "fa-solid fa-spinner fa-spin mr-2";
